import lazyLoadOnRender from '../lazy/loadOnRender';

const LazyAdminPremiumSetupBanner = () =>
  import(/* webpackChunkName: "4-feat-admin-premium-setup-banner" */ './AdminPremiumSetupBanner');

export default lazyLoadOnRender({ loader: LazyAdminPremiumSetupBanner });
